import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import MainLayout from '@/components/layout/MainLayout'
import ErrorBoundary from '@/components/ui/ErrorBoundary'

const AuthPage = lazy(() => import('@/pages/AuthPage'))
const CalendarPage = lazy(() => import('@/pages/CalendarPage'))
const DataPage = lazy(() => import('@/pages/DataPage'))
const EventsPage = lazy(() => import('@/pages/EventsPage'))
const ProfilePage = lazy(() => import('@/pages/ProfilePage'))
const VaultPage = lazy(() => import('@/pages/VaultPage'))
const PeriodPage = lazy(() => import('@/pages/PeriodPage'))
const SpacesPage = lazy(() => import('@/pages/SpacesPage'))
const SpaceDetail = lazy(() => import('@/pages/SpacesPage/SpaceDetail'))
const LegalPage = lazy(() => import('@/pages/LegalPage'))
const SpaceManagePage = lazy(() => import('@/pages/SpaceManagePage'))
const ReportPage = lazy(() => import('@/pages/ReportPage'))
const AboutPage = lazy(() => import('@/pages/AboutPage'))
const AdminPage = lazy(() => import('@/pages/AdminPage'))
const MessagesPage = lazy(() => import('@/pages/MessagesPage'))

function PageLoader() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      color: 'var(--text-sec)',
      fontSize: 14,
    }}>
      Loading...
    </div>
  )
}

export default function App() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)

  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/legal/:type" element={<LegalPage />} />
        <Route path="/about" element={<AboutPage />} />

        {isAuthenticated ? (
          <Route element={<MainLayout />}>
            <Route path="/" element={<CalendarPage />} />
            <Route path="/data" element={<DataPage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/vault" element={<VaultPage />} />
            <Route path="/period" element={<PeriodPage />} />
            <Route path="/spaces" element={<SpacesPage />} />
            <Route path="/space-manage" element={<SpaceManagePage />} />
            <Route path="/space/:id" element={<SpaceDetail />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        ) : (
          <>
            <Route path="/login" element={<AuthPage />} />
            <Route path="/register" element={<AuthPage />} />
            <Route path="/forgot" element={<AuthPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}
